// src/components/buttons/DangerButton.tsx
import React from 'react';
import { cn } from '../../utils/tw';
import { AlertTriangle } from 'lucide-react';

interface DangerButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const DangerButton: React.FC<DangerButtonProps> = ({
  loading,
  icon,
  children,
  className,
  disabled,
  ...props
}) => {
  return (
    <button
      {...props}
      disabled={loading || disabled}
      className={cn(
        'bg-gradient-to-r from-error-500 to-error-600',
        'text-white font-semibold px-6 py-3 rounded-xl',
        'shadow-lg shadow-error-500/30 hover:shadow-xl hover:shadow-error-500/40',
        'transform hover:-translate-y-0.5',
        'transition-all duration-200',
        'focus:outline-none focus:ring-4 focus:ring-error-500/30',
        'disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none',
        'flex items-center justify-center gap-2 min-h-[44px]',
        className
      )}
    >
      {loading ? (
        <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
      ) : (icon || <AlertTriangle size={18} />)}
      {children}
    </button>
  );
};

export default DangerButton;
